<ng-container *ngFor="let key of favouriteKeys">
  <div
    *ngIf="!!log && hasLog(key, log)"
    [innerHTML]="normalizeLog(key, log) | changeLogsDiffHTML: favouriteLookup : null"
  ></div>
</ng-container>
